import React from 'react';

import { Index } from '../components/Index';

export default function IndexPage() {
  return <Index />;
}
